import { useEffect } from 'react';
import { connect } from 'react-redux';
import sortBy from 'lodash/sortBy';
import { setDonations } from '~/actions/donation';
import { getDonations } from '~/api/NewViewer';
import { fixDateString } from '~/utils/date';
const StaticClient = ({ eventId, setDonations }) => {
    useEffect(() => {
        const fetchDonations = async () => {
            try {
                const donations = await getDonations(eventId);
                setDonations(sortBy(donations, donation => new Date(fixDateString(donation.createdDate)).getTime() * -1));
            }
            catch (error) {
                console.log('Get Donation API error', error);
            }
        };
        fetchDonations();
    }, []);
    return null;
};
const mapDispatchToProps = (dispatch) => ({
    setDonations: (donations) => dispatch(setDonations(donations)),
});
const mapStateToProps = (state) => ({
    eventId: state.event.data.id,
    donations: state.donation.donations,
});
export default connect(mapStateToProps, mapDispatchToProps)(StaticClient);
